import React from 'react';
import { CloseButton } from '../../../../../components/common';

import './portal-detail-layout.scss';

interface PortalDetailLayoutProps {
    onClose?: () => void;
}

export const PortalDetailLayout: React.FC<PortalDetailLayoutProps> = ({ onClose, children }): React.ReactElement => {
    const handleClose = () => {
        onClose?.call(null);
    };

    return (
        <div className="portal-detail-layout">
            <CloseButton onClick={handleClose} />
            {children}
        </div>
    );
};
